export default function createLogger(prefix) {
  // const mPrefix = `%c[${prefix}] `
  return {
    log: function log() {
      // console.log(mPrefix, 'color: blue;', ...args)
    },
    warn: function warn() {
      // console.warn(mPrefix, 'color: orange;', ...args)
    },
    errlog: function errlog() {
      // console.error(mPrefix, 'color: red;', ...args)
    }
  };
}